import { render, staticRenderFns } from "./PageSteps.vue?vue&type=template&id=3fac1259"
import script from "./PageSteps.vue?vue&type=script&lang=ts"
export * from "./PageSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports